import { useAppSelector } from "@/redux/hooks";
import { getRetailerFromId } from "@brandclub/common-ui";

export const useRetailerName = (id: number) => {
  const retailers = useAppSelector((state) => state.retailers);
  const retailerNameMap = useAppSelector((state) => state.retailerNameMap);
  const existingRetailer = retailers.find(
    (retailer) => retailer.retailerId === id
  );
  return existingRetailer?.displayName || retailerNameMap[id] || getRetailerFromId(id);
};
